module.exports = __webpack_public_path__ + "img/mcarnev.3fffd071.gif";